// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/workdoc/preview/PreviewWorkDoc.css
// module id = 2048
// module chunks = 0